import styled, { css } from 'styled-components';
import { theme, toRem } from 'design';

// UI
export const MPContent = styled.div<{ $smallGutter?: boolean }>`
  position: relative;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: auto;
  padding: 0 ${toRem(theme.space.xl)};

  .cash-toggle {
    margin-right: ${toRem(theme.space.xs)};
    gap: ${toRem(theme.space.xs)};
  }

  @media (min-width: ${theme.breakpoint.small}px) {
    padding: 0 ${toRem(theme.space['3xl'])};

    ${({ $smallGutter }) =>
      $smallGutter &&
      css`
        padding: 0 ${toRem(theme.space.xl)};
      `}
  }
`;
